import React from "react";

interface VideoPlayIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  color?: string;
}

const VideoPlayIcon: React.FC<VideoPlayIconProps> = ({
  width = "28",
  height = "28",
  color = "#A41E35",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9993 0.666992C6.63935 0.666992 0.666016 6.64033 0.666016 14.0003C0.666016 21.3603 6.63935 27.3337 13.9993 27.3337C21.3594 27.3337 27.3327 21.3603 27.3327 14.0003C27.3327 6.64033 21.3594 0.666992 13.9993 0.666992ZM13.9993 24.667C8.11935 24.667 3.33268 19.8803 3.33268 14.0003C3.33268 8.12033 8.11935 3.33366 13.9993 3.33366C19.8793 3.33366 24.666 8.12033 24.666 14.0003C24.666 19.8803 19.8793 24.667 13.9993 24.667ZM10.666 20.0003L19.9993 14.0003L10.666 8.00033V20.0003Z"
        fill={color}
      />
    </svg>
  );
};

export default VideoPlayIcon;
